export const isInvestorUnlinked = (cmgEntityKey: string | undefined) => {
  return !!cmgEntityKey?.startsWith('firmKey:');
};
